import { Box, Typography, Stack } from '@mui/material';

type PlanInfoProps = {
  label: React.ReactNode;
  planName: string;
  price: number;
  color?: string;
  currency?: 'CZK' | 'EUR';
};

const PlanInfo = ({
  label,
  planName,
  price,
  color = 'primary',
  currency = 'CZK',
}: PlanInfoProps) => (
  <Box>
    <Typography variant="subtitle2" fontWeight={700} color="text.secondary" gutterBottom>
      {label}
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" color={color} fontWeight={700}>
        {planName}
      </Typography>
      <Typography variant="body2">
        {currency === 'EUR' ? `€ ${price}/měsíc` : `Kč ${price}/měsíc`}
      </Typography>
    </Stack>
  </Box>
);

export default PlanInfo;
